import * as React from 'react';
import { SVGProps } from 'react';

const FileIconMovSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      d="M7.5 4.382a1.494 1.494 0 0 0-1.7-.209V4H5v5h1V5.5a.5.5 0 0 1 1 0V9h1V5.5a.5.5 0 0 1 1 0V9h1V5.41l-.003-.002A1.5 1.5 0 0 0 7.5 4.382Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 7.4c0 .56-.14.967-.42 1.22-.273.253-.7.38-1.28.38h-.6c-.58 0-1.01-.127-1.29-.38-.273-.253-.41-.66-.41-1.22V5.6c0-.56.137-.967.41-1.22.28-.253.71-.38 1.29-.38h.6c.58 0 1.007.127 1.28.38.28.253.42.66.42 1.22v1.8Zm-1-1.75c0-.207-.063-.367-.19-.48-.127-.113-.313-.17-.56-.17h-.5c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h.5c.247 0 .433-.057.56-.17.127-.113.19-.273.19-.48v-1.7Z"
      fill="#fff"
    />
    <path d="M16 4h1v3h1V4h1v3l-1 2h-1l-1-2V4Z" fill="#fff" />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 12v13H5V12h14Zm-3 12h2v-2h-2v2Zm0-3h2v-2h-2v2Zm-1-2v5.056H9V19h6Zm0-1H9v-5.056h6V18Zm1 0h2v-2h-2v2Zm0-3h2v-2h-2v2Zm-8 1v2H6v-2h2Zm-2 5v-2h2v2H6Zm0 1v2h2v-2H6Zm2-7v-2H6v2h2Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconMovSizeS;
